import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getHeaderFooter,
  resourceSelector,
} from "../../store/config/configurationSlice";
import { isEmpty } from "lodash";
const Header = () => {
  const data = useSelector(resourceSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isEmpty(data)) dispatch(getHeaderFooter());
    // eslint-disable-next-line
  }, [dispatch]);
  useEffect(() => {
    if (data) {
      //Setting CSS using Map Function Ends
      setTimeout(() => {
        //your code to be executed after 2 second
        data?.cssResourcePaths?.forEach((cssUrlValue) => {
          const cssFile = document.createElement("link");
          cssFile.href = cssUrlValue;
          cssFile.rel = "stylesheet";
          document.head.appendChild(cssFile);
        });

        //Setting JS using Map Function Ends
        data.jsResourcePaths?.forEach((jsUrlValue) => {
          const scriptFile = document.createElement("script");
          scriptFile.src = jsUrlValue;
          document.body.appendChild(scriptFile);
        });
      }, 200);
    }
  }, [data]);
  return (
    !isEmpty(data) && (
      <Fragment>
        <div id="myAeroNavMnuDvNew" dangerouslySetInnerHTML={{ __html: data?.headerMarkup }}></div>
      </Fragment>
    )
  );
};
export default Header;
